var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"move",attrs:{"slot":"header"},slot:"header"},[_c('h3',[_vm._v("Broker Settled Leaderboards")])]),_vm._v(" "),_c('horizontal-bar-chart',{staticClass:"col-12",style:({'height': ((_vm.totalBrokers * 40) + 70) + 'px'}),attrs:{"data":_vm.datasets,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }